import React, { useState } from 'react';
import { Image, StyleSheet, Text, View } from 'react-native';
import { COLORS } from '../../theme/themeTokens';
import { xStockTicker } from '../../utils/xstocks';

interface StockIconProps {
  symbol: string;
  iconUrl?: string | null;
  size?: number;
}

/**
 * Stock logo from the admin-set icon URL, or the ticker's first letter when
 * there is none or it fails to load. Crypto icons use getTokenIconSource,
 * whose USDT fallback would be misleading for a stock.
 */
const StockIcon: React.FC<StockIconProps> = ({ symbol, iconUrl, size = 22 }) => {
  const [failed, setFailed] = useState(false);
  const dimensions = { width: size, height: size, borderRadius: size / 2 };

  if (iconUrl && !failed) {
    return (
      <Image
        source={{ uri: iconUrl }}
        style={[styles.image, dimensions]}
        resizeMode="cover"
        onError={() => setFailed(true)}
      />
    );
  }
  return (
    <View style={[styles.placeholder, dimensions]}>
      <Text style={[styles.letter, { fontSize: Math.round(size * 0.45) }]}>
        {xStockTicker(symbol).charAt(0).toUpperCase()}
      </Text>
    </View>
  );
};

const styles = StyleSheet.create({
  image: { backgroundColor: COLORS.pureLight },
  placeholder: { backgroundColor: COLORS.steelNavy, alignItems: 'center', justifyContent: 'center' },
  letter: { color: COLORS.white, fontWeight: '600' },
});

export default StockIcon;
